// extracted by mini-css-extract-plugin
module.exports = {"item":"ProductsItem_item__2vj1x"};